import { classed } from "@tw-classed/core";
import { withClassName } from "../../helpers";
import type { ButtonProps } from "./button.types";

const classedIcon = classed("", {
  variants: {
    size: {
      xs: "text-[16px]",
      sm: "text-[20px]",
      md: "text-[24px]",
      lg: "text-[26px]",
      xl: "text-[28px]",
    },
  },
});

export const getIconClass = withClassName((props: Pick<ButtonProps, "size">) => classedIcon(props));
